import { render, staticRenderFns } from "./WorkSpaces.vue?vue&type=template&id=79ed1ce4&"
import script from "./WorkSpaces.vue?vue&type=script&lang=js&"
export * from "./WorkSpaces.vue?vue&type=script&lang=js&"
import style0 from "./WorkSpaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports